"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RescheduleActivityValidation = void 0;
var date_fns_1 = require("date-fns");
var yup = __importStar(require("yup"));
exports.RescheduleActivityValidation = yup.object({
    startDate: yup
        .date()
        .min((0, date_fns_1.startOfDay)(new Date()), 'Start Date must be today or later')
        .max(yup.ref('endDate'), 'Start Date must be before End Date')
        .required('Start Date is required'),
    endDate: yup
        .date()
        .min(yup.ref('startDate'), 'End Date must be after Start Date')
        .required('End Date is required'),
    schoolDays: yup
        .array()
        .min(1, 'At least 1 school day must be selected')
        .required('School Days are required'),
});
